export default __webpack_public_path__ + "static/avatar-alex-allan-6fcbe90d2056291f19907beaa83210cb.jpg";